import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Attest from './Attest';

function AttestRouter() {
  return (
    <Routes>
      <Route path="attest" element={<Attest />} />
    </Routes>
  );
}

export default AttestRouter;
